module.exports = __webpack_public_path__ + "img/IT0000374287291.d2ba771d.png";